<template>
    <div>
        <DCard
            padding
        >
            <DCol class="mb-3">
                <DRow class="align-items-center">
                    <DCol
                        sm="3"
                        class="pt-1"
                    >
                        <DInput
                            v-model="filters.search"
                            :label="$t('common.search')"
                            class="mb-0"
                        />
                    </DCol>
                    <DCol
                        sm="6"
                        class="d-flex gap-3"
                    >
                        <DFormCheck
                            v-model="filters.deactivatedUsers"
                            class="mt-4 disabled-users"
                            :label="$t('users.filter_disabled_users')"
                        />
                        <DButton
                            id="filter-apply"
                            class="mt-4"
                            :label="$t('common.filter')"
                            @click="changePage(1)"
                        />
                        <DButton
                            id="filter-reset"
                            class="mt-4"
                            icon="filter-off"
                            :label="$t('common.reset_filters')"
                            @click="resetFilters"
                        />
                    </DCol>
                </DRow>
            </DCol>
            <DTable
                :items="users.data"
                :fields="[
                    {key: 'id', label: $t('users.table_id')},
                    {key: 'name', label: $t('users.table_name')},
                    {key: 'email', label: $t('users.table_email')},
                    {key: 'role', label: $t('users.table_role')},
                    {key: 'deactivated', label: $t('users.table_status')},
                    {key: 'updated_at', label: $t('users.table_updated_at'), filter: false},
                    {key: 'actions', label: $t('users.table_actions'), filter: false}
                ]"
                hover
                sorter
            >
                <template #updated_at="{item}">
                    <td> {{ $formatDateTime(item.updated_at) }}</td>
                </template>

                <template #role="{item}">
                    <td> {{ item.role === null ? '' : item.role }}</td>
                </template>

                <template #deactivated="{item}">
                    <td> {{ item.deactivated ? $t('users.status_inactive') : $t('users.status_active') }}</td>
                </template>

                <template #actions="{item}">
                    <td>
                        <DDropdown
                            toggler-text="..."
                            add-menu-classes="pt-0 pb-0"
                            :size="'sm'"
                            color="secondary"
                            placement="bottom"
                        >
                            <DDropdownItem
                                @click="openEditModal(item)"
                            >
                                <span>{{ $t('users.action_edit_role') }}</span>
                            </DDropdownItem>
                            <DDropdownItem
                                @click="changeStatus(item)"
                            >
                                <span>{{ item.deactivated ? $t('users.action_reenable') : $t('users.action_disable') }}</span>
                            </DDropdownItem>
                        </DDropdown>
                    </td>
                </template>
            </DTable>
        </DCard>
        <DPagination
            v-if="users.last_page > 1"
            class="pb-2"
            :active-page="users.current_page"
            :pages="users.last_page"
            align="center"
            @update:active-page="changePage"
        />
        <UserEditModal
            v-if="showEditModal"
            :user="selectedUser"
            :show-modal="showEditModal"
            :roles="roles"
            @close-modal="closeEditModal"
        />
        <UserCreateModal
            v-if="showCreateModal"
            :roles="roles"
            :show-modal="showCreateModal"
            :create-form="form"
            :errors="errors"
            @close-modal="closeCreateModal"
            @save-user="saveUser"
        />
        <DFabs>
            <DFab
                icon="plus"
                @click="openCreateModal"
            />
        </DFabs>
    </div>
</template>

<script>
import UserEditModal from '~@/Pages/Users/EditRole'
import UserCreateModal from '~@/Components/Users/Modals/Create'
import { router, useForm } from '@inertiajs/vue3'

export default {
    name: 'UserIndex',
    components: {
        UserEditModal,
        UserCreateModal
    },
    props: {
        users: {
            type: Object,
            default: () => { return {} }
        },
        roles: {
            type: Array,
            default: () => { return [] }
        },
        filtersData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        return {
            filters: this.filtersData,
            selectedUser: {},
            showEditModal: false,
            showCreateModal: false,
            form: useForm({
                role: null,
                name: null,
                email: null,
                password: null
            })
        }
    },
    methods: {
        openCreateModal () {
            this.showCreateModal = true
        },
        closeCreateModal () {
            this.showCreateModal = false
            this.form.role = null
            this.form.name = null
            this.form.email = null
            this.form.password = null
        },
        openEditModal (item) {
            this.selectedUser = item
            this.showEditModal = true
        },
        closeEditModal () {
            this.showEditModal = false
        },
        changeStatus (item) {
            router.patch(this.$route('users.change-status', { user: item.id }))
        },
        changePage (page) {
            const queryParameters = Object.fromEntries(Object.entries(this.filters).filter(([_, v]) => v))

            if (page !== 1) {
                queryParameters._query = { page }
            }

            router.get(this.$route('users.index', queryParameters))
        },
        resetFilters () {
            router.get(this.$route('users.index', { page: this.users.current_page }))
        },
        saveUser (form) {
            form.post(this.$route('users.store'), {
                onSuccess: () => {
                    this.closeCreateModal()
                }
            })
        }
    }
}
</script>

<style lang="scss">
.disabled-users {
    display: flex;
    gap: 6px;
    align-items: center;

    & label {
        margin-top: 12px;
    }
}
</style>
